import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    br: "br",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "Clause 1 (Purpose)"
    }), "\n", _jsx(_components.p, {
      children: "The purpose of these Terms of Service is to define the content, usage conditions, procedures, rights and obligations, and other necessary matters between SELLER-NOTE Inc. (hereinafter referred to as \"the Company\") and the users of the ShipDa service (hereinafter referred to as \"the Service\"). These Terms of Service also apply to electronic commerce conducted via PC, mobile web, and mobile apps related to the Service."
    }), "\n", _jsx(_components.h3, {
      children: "Clause 2 (Definition and Interpretation of Terms)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "'Shipper' refers to a user of the 'Service' who requests international logistics brokerage. The Shipper can register as a member through the 'Website' or 'App' and request international logistics brokerage, or after registering as a member, use the 'Service' through the Website or customer 'App'."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "'ShipDa' refers to the service provided by SELLER-NOTE Inc., which holds a license for international logistics brokerage and offers international logistics brokerage services."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "'User' refers to a 'Shipper' who has used or wishes to use the ShipDa service."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "'Service' refers to all services provided to 'Users' through ShipDa by the Company."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "'Request Export/Import Freight Quote' refers to a service where the Shipper registers information about the region and cargo requiring logistics services. ShipDa then provides an immediate or time-limited quotation for the request. If the Shipper accepts the quotation, the export/import logistics are carried out."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 3 (Applicable Laws and Regulations)"
    }), "\n", _jsx(_components.p, {
      children: "Matters not stipulated in these Terms of Service shall be governed by the Act on Promotion of Information and Communications Network Utilization and Information Protection (Information and Communications Network Act), the Act on Consumer Protection in Electronic Commerce, the Commercial Act, and other relevant laws and regulations of South Korea, as well as customary practices."
    }), "\n", _jsx(_components.h3, {
      children: "Clause 4 (Provision and Changes of the Service)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Service is provided 24 hours a day, 7 days a week, unless there are special operational or technical issues. However, this excludes days or times designated by the Company for regular maintenance. The maintenance schedule will be announced through the service interface."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company does not grant any rights to the intellectual property of the Company (including but not limited to copyrights, trademarks, logos, graphics, photos, animations, videos, and text or rights related to the app and its applications) or the intellectual property of the Company's retail or advertising partners to the users."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If users request to engage in transactions separately from the Company’s services, restrictions may arise in using the Service."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The use of services and apps provided by the Company is free of charge. However, through services provided by the Company, users are obligated to pay fees as specified in Clause 5."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 5 (Fees and Charges)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The 'fee' for using the Service is applied to the 'scope of export/import logistics requested from the Company', and the corresponding cost will be billed based on the type of cargo, volume, weight, container type, number of containers, and other criteria, rather than the cargo information input by the customer. The point at which the fee is charged to the Shipper will depend on the export/import type and Incoterms, as follows:"
        }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                style: {
                  textAlign: "left"
                },
                children: "Category"
              }), _jsx(_components.th, {
                style: {
                  textAlign: "left"
                },
                children: "Export"
              }), _jsx(_components.th, {
                style: {
                  textAlign: "left"
                },
                children: "Import"
              })]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "E Terms (EXW)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Not applicable"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Upon arrival at the destination port/airport"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "F Terms (FOB, FCA)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "After loading at the departure port/airport"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Upon arrival at the destination port/airport"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "C Terms (CIF, CFR, CIP, CPT)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Upon arrival at the destination port/airport"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Upon arrival at the destination port/airport"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "D Terms (DAP, DDP)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Upon arrival at the final destination"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "Not applicable"
              })]
            })]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the Shipper requests cancellation after the Company has performed certain tasks (such as transportation, customs clearance, etc.) following the request, the Company will charge all incurred costs, and the Shipper shall not dispute the legitimate cost claims."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The 'fee' can be paid using a payment method recognized by the Company, and detailed 'quotation items/costs/additional actual costs' can be checked through the ShipDa service's 'Quotation'. The full breakdown of all costs will be available in the 'Invoice' through the ShipDa service. Since quotations are estimates, the 'Invoice' represents the total actual costs incurred during the transportation process. Billing will be based on the invoice."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company may charge additional fees from the User in the following cases:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "If additional work or costs arise due to the Shipper's needs beyond the originally requested scope or due to transportation circumstances, the Company will notify the Shipper and provide an estimate."
          }), "\n", _jsx(_components.li, {
            children: "If agreed upon in writing or by phone between the Shipper and the Company, the Company will process this request and charge the 'fee' for the service based on actual costs."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If there are outstanding costs, damages, or other debts from the Shipper to the Company related to the Service, the Shipper's use of the Service will be suspended until the debt is settled. If the debt remains unpaid for a certain period, the Shipper's membership may be revoked. The criteria for service suspension or membership revocation are based on the Company's Terms of Service and usage policies."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the Shipper fails to comply with these Terms of Service and the clauses above, the Company reserves the right to terminate the contract in addition to imposing penalties or fees as specified in these Terms and usage policies."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If outstanding costs, damages, or other debts from the Shipper to the Company are not settled, the Company may take legal actions, including securing provisional remedies, filing lawsuits, or initiating enforcement procedures to recover the debt."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 6 (Obligations of Service Users)"
    }), "\n", _jsx(_components.p, {
      children: "Users must comply with the relevant laws, the provisions of these Terms of Service, usage guidelines, and other matters notified by the Company. The User shall not engage in any activities that interfere with the Company’s operations. Users must carefully review the Terms of Service and other documents, as any issues arising during operations due to a failure to check these documents will be the sole responsibility of the User."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The User must confirm the detailed content and terms of the transaction before starting. Any losses or damages arising from proceeding with a transaction without confirming the details and terms of the transaction will be the responsibility of the User."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The information entered by the User must be truthful. If the User inputs false or fraudulent information, causing harm to the Company or other users, the User will bear full responsibility, including civil and criminal liability."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The User must use the Service according to the methods prescribed and recognized by the Company."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The User must not engage in any of the following acts related to the use of the Service:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Registering false information during the application or modification of the Service"
          }), "\n", _jsx(_components.li, {
            children: "Making unauthorized changes to the information posted by the Company"
          }), "\n", _jsx(_components.li, {
            children: "Sending or posting information (such as computer programs) other than the information specified by the Company, including creating an internet “link” to ShipDa’s Service or framing or mirroring the app on other servers or wireless/Internet-based devices"
          }), "\n", _jsx(_components.li, {
            children: "Using another person’s personal information, ID, or password without authorization"
          }), "\n", _jsx(_components.li, {
            children: "Collecting, storing, disclosing, or processing another person’s personal information without consent"
          }), "\n", _jsx(_components.li, {
            children: "Infringing upon the copyrights or intellectual property rights of the Company or third parties"
          }), "\n", _jsx(_components.li, {
            children: "Defaming or interfering with the business of the Company or third parties"
          }), "\n", _jsx(_components.li, {
            children: "Posting or disclosing obscene, violent, or other content that violates public order and morals"
          }), "\n", _jsx(_components.li, {
            children: "Posting content that disrupts the Company’s operations without legitimate reasons"
          }), "\n", _jsxs(_components.li, {
            children: ["Engaging in any actions to replicate, deconstruct, imitate, or modify the Service through reverse engineering, or other means to access the app for the following purposes:\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: "Reverse engineering or designing or creating competitive products or services"
              }), "\n", _jsx(_components.li, {
                children: "Designing or creating products that use similar ideas, features, functions, or graphics as the Service or app"
              }), "\n", _jsx(_components.li, {
                children: "Replicating the ideas, features, functions, or graphics of the Service or app"
              }), "\n", _jsx(_components.li, {
                children: "Using automatic access programs or methods that deviate from normal usage to overload the Company's servers and disrupt normal service, such as executing web spiders, web crawlers, web robots, web ants, web indexers, bots, viruses, or worms"
              }), "\n", _jsx(_components.li, {
                children: "Engaging in any other act that violates applicable laws or the regulations set by the Company"
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 7 (Information and Posts Related to Shipping Request Registration)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the 'Shipping request registered information' or 'posts' of the User contain content that violates relevant laws such as the Information and Communications Network Act and the Copyright Act, the Company shall comply with the procedures prescribed by the relevant laws to request the suspension or deletion of the 'registered information' or 'posts' and take appropriate actions according to the applicable laws."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Even without such a request mentioned in the previous paragraph, if there are grounds for acknowledging rights infringement or if the content violates the Company’s policies or relevant laws, the Company may take temporary measures such as removing the 'registered information' or 'posts' in accordance with the applicable laws."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The copyright of posts made by the User belongs to the User. However, the Company may use the User’s posts without separate permission for purposes related to the operation, exhibition, transmission, distribution, and promotion of the Service, in accordance with the fair practices as stipulated by copyright law."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the Company wishes to use the User’s posts for purposes other than those mentioned in the previous paragraph, the Company must obtain the User's consent in advance through methods such as telephone or email."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "All rights and responsibilities related to the 'registered information' or 'posts' created by the User rest with the User who made the post. The Company may delete the 'registered information' or 'posts' without prior notice if it determines that the content of the service posted or registered by the User falls into any of the following categories. The Company shall not be liable for such deletions:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Content that defames or damages the reputation of other users or third parties"
          }), "\n", _jsx(_components.li, {
            children: "Content that violates public order and morals"
          }), "\n", _jsx(_components.li, {
            children: "Content associated with criminal activities"
          }), "\n", _jsx(_components.li, {
            children: "Content that infringes the Company’s copyrights, third-party copyrights, or other rights"
          }), "\n", _jsx(_components.li, {
            children: "Posting obscene material or linking to obscene websites"
          }), "\n", _jsx(_components.li, {
            children: "Posting commercial advertisements or promotional content without prior approval from the Company"
          }), "\n", _jsx(_components.li, {
            children: "Content unrelated to the relevant product"
          }), "\n", _jsx(_components.li, {
            children: "Content that disrupts the Company’s business operations without legitimate reason"
          }), "\n", _jsx(_components.li, {
            children: "Any content that is judged to violate applicable laws"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 8 (Suspension of Service and User Restrictions)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company may change or suspend all or part of the services it provides for reasons such as difficulties in providing smooth services due to reduced usage, deterioration in profitability, the need for transition to next-generation services due to technological advances, or changes in the Company’s policies related to service provision, or for other substantial reasons."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company may modify, suspend, or change all or part of the free services provided based on the Company’s policies and operational needs. Unless otherwise specifically provided by relevant laws, the Company will not provide separate compensation to users for such modifications or suspensions."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If there are changes or suspensions to the content, usage methods, or usage times of the services, the Company will notify users in advance through methods that users can easily access, such as the Company’s website or service’s notice screen, indicating the details, reasons, and dates of the changes or suspension."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If a user violates the terms of this Agreement or interferes with the normal operation of the service, the Company may restrict the user's service usage in stages, including warnings, temporary suspension, or permanent suspension of service access."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Notwithstanding the previous paragraph, if the user violates relevant laws such as the Resident Registration Act (identity theft and payment fraud), the Copyright Act and the Computer Program Protection Act (providing illegal programs and operating disruptions), the Information and Communications Network Act (illegal communication, hacking, distribution of malicious programs, or exceeding access permissions), the Company may immediately permanently suspend the user’s access. Upon permanent suspension under this clause, any benefits obtained through the use of the service will be forfeited, and the Company will not provide compensation."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The scope of restrictions under this Clause, including conditions and details, will be determined by the Company's user restriction policies."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Users may file an objection regarding service restrictions under this Clause according to the procedures set by the Company. If the Company deems the objection valid, it will immediately resume the user’s access to the service."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 9 (Termination and Cancellation)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Users may terminate the service agreement under these Terms and Conditions. When a user requests to withdraw, the Company will verify their identity and take appropriate actions in accordance with the request."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company may terminate the service agreement after prior notice if the user violates any obligations set forth in these Terms and Conditions. However, if the user has violated current laws, or caused damage to the Company intentionally or through gross negligence, the Company may terminate the agreement without prior notice."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 10 (Company's Responsibilities and Obligations)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "When a Shipper uses the ShipDa service for transportation, the Shipper must comply with 'Incoterms' and any 'additional requests' related to transportation to clarify the responsibilities. However, the Company is not responsible for any export or import customs services, as it provides 'transportation services,' not 'customs services.'"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company will not engage in any acts prohibited by relevant laws or these Terms and Conditions, and will make every effort to provide continuous and stable services."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company must implement security systems to ensure users can safely use the service and must publicly disclose and comply with its privacy policy regarding the collection and processing of personal information."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company will comply with all obligations as stipulated by relevant laws."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 11 (Company's Exemption from Liability)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company will be exempt from liability for the provision of services if it is unable to do so due to natural disasters or other force majeure events."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company is not liable for any service interruptions caused by the user's own fault."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company is not responsible for the reliability, accuracy, or any other content of information, materials, or facts posted by users in relation to the service."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company is not responsible for any transactions or dealings between users or between users and third parties conducted through the service."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company has the discretion to delete any offensive, defamatory, or insulting posts made by users in accordance with Articles 4 and 44-7 of the Information and Communications Network Act."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company is not liable for any damages arising from the use of free services, unless there are specific provisions in relevant laws."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company is not responsible for monitoring or overseeing the content and quality of products or services advertised by third parties through the service's screen or linked websites."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company, its employees, and its agents are not responsible for damages arising from the following:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Losses caused by false or inaccurate information provided by the user."
          }), "\n", _jsx(_components.li, {
            children: "Personal losses incurred during access to or use of the service, regardless of their nature or circumstances."
          }), "\n", _jsx(_components.li, {
            children: "Losses caused by illegal access or misuse of the server by third parties."
          }), "\n", _jsx(_components.li, {
            children: "Losses caused by illegal interference or disruption of data transmission to or from the server by third parties."
          }), "\n", _jsx(_components.li, {
            children: "Losses caused by viruses, spyware, and other malicious programs transmitted or disseminated by third parties using the service."
          }), "\n", _jsx(_components.li, {
            children: "Losses arising from errors, omissions, deletions, or destruction of transmitted data."
          }), "\n", _jsx(_components.li, {
            children: "Civil or criminal liabilities arising from defamation or other illegal activities between users during the use of the service."
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 12 (Compensation for Damages)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If a user engages in illegal activities or violates any relevant laws or regulations while using the ShipDa service, regardless of whether mentioned in these Terms, the user must indemnify and hold the Company harmless at their own expense, including any attorney fees."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "In cases where a third party files claims or lawsuits for damages against the Company, its affiliates, Company works, or its officers, employees, other users, staff, lawyers, or agents, the user must indemnify and hold the Company harmless at their own expense, including any attorney fees."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 13 (Modification of the Terms)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company may, at its sole discretion, modify, revise, or replace these Terms at any time."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company will notify users of any changes to these Terms by posting them on the website or app's initial screen so that the user can be informed."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Company may amend these Terms within the scope of relevant laws, such as the \"Act on the Regulation of Terms and Conditions\" and the \"Information and Communications Network Act.\""
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the Company revises these Terms, it will notify users of the revision, including the effective date, details of the changes, and reasons for the revisions, at least 7 days prior to the effective date (for changes that are disadvantageous or significant to users, at least 30 days in advance)."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If the Company notifies users of the revised Terms with a statement that failure to express disagreement by the implementation date will be considered as acceptance, users who do not express disagreement before the effective date will be deemed to have accepted the revised Terms."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "If a user disagrees with the revised Terms, either the Company or the user may terminate the ShipDa service usage agreement."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 14 (Personal Data Protection)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The collection, use, storage, and transfer of personal information of users are generally governed by the Company's Privacy Policy and the information provided when consent is given for the collection of personal data. The latest version of the Privacy Policy is posted on the Company's website."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The Privacy Policy may be modified or updated at the Company's discretion, and such modifications are included in these Terms by reference."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Clause 15 (Governing Law and Jurisdiction)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "The interpretation of these Terms and any disputes between the Company and the user shall be governed by the laws of the Republic of Korea."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Any lawsuits arising between the Company and the user in relation to the use of the service shall be subject to the court procedures established by law, and the Seoul Central District Court shall have exclusive jurisdiction."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.br, {}), "\n", _jsx(_components.p, {
      children: "These Terms will be effective from December 20, 2024."
    }), "\n", _jsx(_components.h4, {
      children: "You can check the details regarding the changes to the Terms of Use below."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "n/a"
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
